import { useState } from 'react';
import { useAtomValue } from 'jotai/index';
import { getBoundaryLabel } from '@marqvision/shared';
import { FilterChip } from '~/components/Dashboard/Monitoring/components/FilterSection/FilterChip';
import { NumberRangePicker } from '~/components/Dashboard/components/NumberRangePicker';
import { useLogger } from '~/hooks';
import { userProfileAtom } from '~/atoms';
import { useGetFilterParams, usePathParams } from '~/components/Filters/@hooks';
import { getListingTabGroup } from '~/utils';
import { ResponsiveProps } from '~/components/Responsive/@types';

const PriceFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const [priceAnchorEl, setPriceAnchorEl] = useState<HTMLElement | null>(null);
  const { amplitudeLogging } = useLogger();
  const userProfile = useAtomValue(userProfileAtom);
  const { page, listingStatus } = usePathParams();
  const { params, setParams, removeParams } = useGetFilterParams();

  const { min_price: selectedMinPrice, max_price: selectedMaxPrice } = params;
  const isDisabled = false;

  const handlePrice = (newMinPrice: number | null, newMaxPrice: number | null) => {
    const isResetValue = (newMinPrice === null && newMaxPrice === null) || (newMinPrice === 0 && newMaxPrice === 0);

    if (isResetValue) {
      removeParams(['min_price', 'max_price']);
    } else {
      const params: Record<string, number | undefined> = {};
      if (newMinPrice !== null) {
        params.min_price = newMinPrice;
      }
      if (newMaxPrice !== null) {
        params.max_price = newMaxPrice;
      }
      setParams(params);

      amplitudeLogging('applied filter', {
        Type: 'price',
        Channel: page, // marketplace, social media..
        Page: getListingTabGroup(listingStatus), // scanned, flagged, in progress, case closed, test purchase
      });
    }
  };

  return (
    <>
      <FilterChip
        isSelect
        size={size}
        variant={selectedMinPrice || selectedMaxPrice ? 'fill' : 'tint'}
        selected={getBoundaryLabel(selectedMinPrice, selectedMaxPrice, userProfile?.client_currency)}
        label="Price"
        disabled={isDisabled}
        onClick={(e: any) => setPriceAnchorEl(e.currentTarget)}
      />
      {priceAnchorEl && (
        <NumberRangePicker
          anchorEl={priceAnchorEl}
          min={selectedMinPrice || null}
          max={selectedMaxPrice || null}
          format="currency"
          onApply={handlePrice}
          onClose={() => setPriceAnchorEl(null)}
        />
      )}
    </>
  );
};

export default PriceFilter;
